import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-130" data-mp="boon97wwy362">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3" data-id="element-131" data-mp="196olggczbawj">
          <a href={CHECKOUT_URL} className="animate-shake mx-auto flex w-full max-w-md items-center justify-between gap-3 rounded-2xl bg-gold px-5 py-3.5 text-ink shadow-[0_10px_30px_-6px_rgba(11,26,46,0.55)] focus:outline-none focus-visible:ring-4 focus-visible:ring-teal" data-id="element-132" data-mp="2f2r2poj4ftkl">
            <span className="flex flex-col leading-tight" data-id="element-133" data-mp="1rcwrtcid4f2z">
              <span className="text-base font-extrabold uppercase tracking-tight" data-id="element-134" data-mp="1wdt3ic8yh5iy">Get instant access</span>
              <span className="text-xs font-semibold text-ink/70" data-id="element-135" data-mp="1iejk73pgdvar">
                <span className="line-through" data-id="element-136" data-mp="1ncuz3suluvzu">$398</span> · Today only $27
              </span>
            </span>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-ink text-gold" data-id="element-137" data-mp="3cr9hzwixzonf">
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-138" data-mp="3hr5ny1b79q5m" />
            </span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}